import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import { TrainerContext, CommonContext } from './../../contexts/constant/ActionTypes';
import Trainer from '../../components/Trainer/Trainer';

const TrainerPage = ({history, match}) => {
    const trainerContext = useContext(TrainerContext);
    const commonContext = useContext(CommonContext);

	return (
    <div>
        <Trainer
            history={history} 
            match={match}
            trainerContext={trainerContext}
            commonContext={commonContext}
        />
    </div>
	);
}

TrainerPage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

TrainerPage.defaultProps = {
    history: {},
    match: {}
};

export default TrainerPage;



// WEBPACK FOOTER //
// ./containers/TrainerPage/TrainerPage.js